/* ==========================================================================
   Visotale — Cart Page interactions
   Gift wrap toggle, gift note counter, coupon apply
   ========================================================================== */

(function() {
  'use strict';

  const cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;

  // ==========================================================================
  // Gift wrap toggle
  // ==========================================================================
  const giftWrapToggle = document.querySelector('[data-gift-wrap-toggle]');
  if (giftWrapToggle) {
    const checkbox = giftWrapToggle.querySelector('input[type="checkbox"]');
    giftWrapToggle.addEventListener('click', async function(e) {
      e.preventDefault();
      const newState = !checkbox.checked;
      checkbox.checked = newState;
      giftWrapToggle.classList.toggle('is-active', newState);

      // Shopify cart attributes ile kaydet
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { gift_wrap: newState ? 'true' : '' }
          })
        });
        // Sayfayı yenile ki özet güncellensin
        window.location.reload();
      } catch (err) {
        console.error('Gift wrap update failed:', err);
        // Rollback
        checkbox.checked = !newState;
        giftWrapToggle.classList.toggle('is-active', !newState);
      }
    });
  }

  // ==========================================================================
  // Gift note character counter
  // ==========================================================================
  const giftNoteInput = document.querySelector('[data-gift-note-input]');
  const giftNoteCount = document.querySelector('[data-gift-note-count]');
  if (giftNoteInput && giftNoteCount) {
    giftNoteInput.addEventListener('input', function() {
      giftNoteCount.textContent = giftNoteInput.value.length;
    });

    // Debounced save
    let saveTimeout;
    giftNoteInput.addEventListener('input', function() {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(async function() {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: { gift_note: giftNoteInput.value }
            })
          });
        } catch (err) {
          console.error('Gift note save failed:', err);
        }
      }, 800);
    });
  }

  // ==========================================================================
  // Coupon apply (Shopify discount codes)
  // ==========================================================================
  const couponInput = document.querySelector('[data-coupon-input]');
  const couponApply = document.querySelector('[data-coupon-apply]');
  if (couponInput && couponApply) {
    couponApply.addEventListener('click', function() {
      const code = couponInput.value.trim();
      if (!code) return;
      // Shopify checkout discount endpoint
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });

    couponInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        couponApply.click();
      }
    });
  }
})();
